import React, { memo, useCallback, useMemo, useState } from 'react';

import PropTypes from 'prop-types';

import CombinedFieldCDS from '../../form/CombinedFieldCDS';

import {
  getEntryFixedDecimalScale,
  getEntryInputProps,
} from './FormGeneratorCombinedFieldCDS.utils';

const FormGeneratorCombinedFieldCDS = ({ entries, ...props }) => {
  const [focusedEntryName, setFocusedEntryName] = useState(null);

  const onBlurEntry = useCallback(() => setFocusedEntryName(null), []);

  const fields = useMemo(
    () =>
      entries.map(({ inputProps, shouldShowRawWhileFocused, fixedDecimalScale, ...entry }) => ({
        ...entry,
        fixedDecimalScale: getEntryFixedDecimalScale({
          fixedDecimalScale,
          shouldShowRawWhileFocused,
          isFocused: focusedEntryName === entry.name,
        }),
        inputProps: getEntryInputProps({
          inputProps,
          onBlur: onBlurEntry,
          onFocus: () => setFocusedEntryName(entry.name),
        }),
      })),
    [entries, focusedEntryName, onBlurEntry],
  );

  return <CombinedFieldCDS fields={fields} {...props} />;
};

FormGeneratorCombinedFieldCDS.propTypes = {
  entries: PropTypes.arrayOf(PropTypes.object).isRequired,
  ...CombinedFieldCDS.propTypes,
};

export default memo(FormGeneratorCombinedFieldCDS);
